/**
 * @generated SignedSource<<09524a2889f1f9beae0ed89714d61dba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useOpenFileMutation$variables = {
  fileId: string;
  position?: number | null;
  queryId?: string | null;
};
export type useOpenFileMutation$data = {
  readonly file: {
    readonly access: string;
  };
};
export type useOpenFileMutation = {
  response: useOpenFileMutation$data;
  variables: useOpenFileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fileId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "position"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "queryId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "fileId"
      }
    ],
    "concreteType": "FileMutation",
    "kind": "LinkedField",
    "name": "file",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "position",
            "variableName": "position"
          },
          {
            "kind": "Variable",
            "name": "queryId",
            "variableName": "queryId"
          }
        ],
        "kind": "ScalarField",
        "name": "access",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useOpenFileMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useOpenFileMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "db4b9a3b8022d7a459509f927b190061",
    "id": null,
    "metadata": {},
    "name": "useOpenFileMutation",
    "operationKind": "mutation",
    "text": "mutation useOpenFileMutation(\n  $fileId: ID!\n  $position: Int\n  $queryId: ID\n) {\n  file(id: $fileId) {\n    access(position: $position, queryId: $queryId)\n  }\n}\n"
  }
};
})();

(node as any).hash = "b64af69c75e1e2a0efd3d429fb125dde";

export default node;
